"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridRow_1 = require("./GridRow");
exports.default = GridRow_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridRow/index.js
// module id = 151
// module chunks = 8